module.exports = __webpack_public_path__ + "img/07_bg.d46b91d1.png";